import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDMLsyjmMPikiLz752GKp_96nlxlAga3no",
  authDomain: "se-litvill.firebaseapp.com",
  projectId: "se-litvill",
  storageBucket: "se-litvill.firebasestorage.app",
  messagingSenderId: "44892985086",
  appId: "1:44892985086:web:1d46904d9d68edd656f7af",
  measurementId: "G-FJ6NK4BKV1"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
